// src/routes/PublicOnlyRoute.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/authContext";

export default function PublicOnlyRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div>Loading...</div>;
  return user ? <Navigate to="/" replace /> : children;
}
